import type { UserOrganizationHeaderProps } from "./user-organization-header.type";

import { Flex, Spin } from "antd";
import { useTranslation } from "react-i18next";

import { MODEL_KEY } from "@/modules/model";
import ModelIcon from "@/modules/model-icon";

import { UserOrganizationHeaderAlert } from "./user-organization-header-alert";
import { UserOrganizationHeaderCard } from "./user-organization-header-card";
import { UserOrganizationHeaderMainRole } from "./user-organization-header-main-role";

export const UserOrganizationHeader = ({
  mainRole,
  user,
  loading,
}: UserOrganizationHeaderProps) => {
  const { t } = useTranslation();
  const organizationName = user?.organization?.name;

  if (loading) return <Spin />;

  if (!user) return null;

  if (!mainRole) {
    return <UserOrganizationHeaderAlert user={user} />;
  }

  return (
    <Flex gap="middle">
      <UserOrganizationHeaderMainRole mainRole={mainRole} user={user} />
      {organizationName && (
        <UserOrganizationHeaderCard
          title={organizationName}
          icon={<ModelIcon model={MODEL_KEY.ORGANIZATION} />}
          secondaryTitle={t("global:organization")}
          fixedWidth
        />
      )}
    </Flex>
  );
};
